import { gql } from '@apollo/client';
import { CHAPTER_FIELDS } from './chapter';
import { CONCEPT_FIELDS } from './concept';
import { HIGHLIGHT_FIELDS } from './highlight';
import { PICTURE_FIELDS } from './picture';

export const QUESTION_COMMENT_FIELDS = gql`
  fragment QuestionCommentFields on QuestionComment {
    id
    createdAt
    comment
    parentId
    likes
    user {
      id
      displayName
      accessLevel
    }
    review
    dislikes
    isLikedByMe
    questionId
    replies {
      id
      createdAt
      comment
      parentId
      user {
        id
        displayName
        accessLevel
      }
      likes
      review
      dislikes
      isLikedByMe
      questionId
    }
  }
`;

export const QUESTION_UKMLA_FIELDS = gql`
  fragment QuestionUkmlaFields on Question {
    presentations {
      id
      name
    }
    conditions {
      id
      name
    }
    areas {
      id
      name
    }
    conditionAreaIds
    presentationAreaIds
  }
`;

export const QUESTION_UCAT_FIELDS = gql`
  ${CHAPTER_FIELDS}
  fragment QuestionUcatFields on Question {
    themes {
      id
      name
      entitlementId
      entitlement {
        id
        name
      }
    }
    # irtParameters {
    #   discrimination
    #   difficulty
    #   guessing
    # }
    timeTaken
    avgTimeTaken
    stem {
      ...ChapterFields
    }
  }
`;

export const QUESTION_CATEGORY_FIELDS = gql`
  fragment QuestionCategoryFields on Question {
    ... on QuestionSBA {
      sbaAnswer: answer
    }
    ... on QuestionQA {
      qaAnswer: answer {
        dose
        units
      }
    }
    ... on QuestionEMQ {
      cases {
        id
        questionId
        case
        explanation
        label
      }
      emqAnswer: answer
    }
    ... on QuestionMultiA {
      multiAnswer: answer
    }
    ... on QuestionRanking {
      rankingAnswer: answer
    }
    ... on QuestionSelect3 {
      select3Answer: answer
    }
    ... on QuestionPrescription {
      prescriptions{
        drugId
        drugVisible
        doseId
        doseVisible
        routeId
        routeVisible
        frequencyId
        frequencyVisible
        durationId
        durationVisible
        index
        questionId
      }
      prescribeAnswer: answer {
        dose {
          value
          label
          visible
        }
        drug {
          value
          label
          visible
        }
        route {
          value
          label
          visible
        }
        frequency {
          value
          label
          visible
        }
        duration {
          value
          label
          visible
        }
      }
    }
  }
`;

export const QUESTION_FIELDS = gql`
  ${QUESTION_UCAT_FIELDS}
  ${QUESTION_UKMLA_FIELDS}
  ${HIGHLIGHT_FIELDS}
  ${QUESTION_CATEGORY_FIELDS}
  ${QUESTION_COMMENT_FIELDS}
  ${CONCEPT_FIELDS}
  ${PICTURE_FIELDS}
  fragment QuestionFields on Question {
    id
    conceptId
    difficulty
    aiGenerated
    dislikes
    explanation
    learningPoint
    isLikedByMe
    userPoint
    likes
    question
    totalVotes
    typeId
    psaSectionId
    highlights {
      ...HighlightFields
    }
    choices {
      id
      explanation
      name
      label
      answer
      votes
      picture {
        ...PictureFields
      }
      pictures {
        ...PictureFields
      }
    }
    comments {
      ...QuestionCommentFields
    }
    concept {
      # needed for daily stack
      totalCards
      ...ConceptFields
    }
    pictures {
      ...PictureFields
    }
    ...QuestionUkmlaFields
    ...QuestionCategoryFields
    ...QuestionUcatFields
  }
`;

// used in cache updator
export const QUESTION_WITH_HIGHLIGHT_FIELDS = gql`
  fragment QuestionWithHighlightFields on Question {
    highlights {
      start
      end
      text
      part
      tag
      color
    }
  }
`;

// used in cache updator
export const QUESTION_WITH_COMMENT_FIELDS = gql`
  ${QUESTION_COMMENT_FIELDS}
  fragment QuestionWithCommentFields on Question {
    id
    likes
    dislikes
    isLikedByMe
    comments {
      ...QuestionCommentFields
    }
  }
`;

// used in cache updator
export const QUESTION_WITH_LEARNING_FIELDS = gql`
  fragment QuestionWithLearningFields on Question {
    userPoint
  }
`;
